import { darken, lighten, readableColor, rem } from 'polished';
export const mediaSizes = {
    xxs: 320,
    xs: 480,
    s: 600,
    m: 768,
    l: 992,
    xl: 1100,
    xxl: 1200,
    xxxl: 1350,
};
export function mb(from) {
    if (typeof from === 'string') {
        if (from in mediaSizes) {
            return `@media (min-width: ${rem(mediaSizes[from])})`;
        }
        else {
            throw new Error(`mb: Media size "${from}" is not defined. Use one of [${Object.keys(mediaSizes)}]`);
        }
    }
    if (typeof from !== 'number') {
        throw new Error(`mb: Invalid media breakpoint argument "${from}"`);
    }
    return `@media (min-width: ${rem(from)})`;
}
export const emphasizeColor = (amount, color, reverse = false) => {
    try {
        const isColorDark = readableColor(color, '#fff', '#000', false) === '#000';
        if (isColorDark && reverse) {
            return lighten(amount, color);
        }
        else if (isColorDark) {
            return darken(amount, color);
        }
        else if (!isColorDark && reverse) {
            return darken(amount, color);
        }
        else {
            return lighten(amount, color);
        }
    }
    catch (e) {
        console.warn({
            error: e,
            opts: {
                amount,
                color,
                reverse,
            },
        });
        return color;
    }
};
